import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Container,
  Row,
  Col,
  Form,
  Card,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import { getVendor, updateVendor } from "../../store/slices/vendor";
import { emailregex, mobileregex } from "../../utils/Regex";
import { toast } from "react-toastify";
import { useNavigate, Link, useParams } from "react-router-dom";
import Select from "react-select";

const stateOptions = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

export default function EditVendor() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { id } = useParams();
  const serviceOptions = [
    { value: "HOTEL", label: "Hotel" },
    { value: "VEHICLE", label: "Vehicle" },
    { value: "ACTIVITY", label: "Activity" },
    { value: "FERRY", label: "Ferry" },
    { value: "GUIDE", label: "Guide" },
    { value: "TRANSFER", label: "Transfer" },
  ];

  const initialform = {
    name: "",
    contactPerson: "",
    mobileNumber: "",
    email: "",
    address: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    gstNumber: "",
    panNumber: "",
    creditDays: "",
    paymentTerms: "",
    notes: "",
    bankDetails: {
      accountName: "",
      accountNumber: "",
      ifscCode: "",
      bankName: "",
      branch: "",
    },
  };

  const [form, setForm] = useState(initialform);

  const [service, setService] = useState([]);

  const [submitloading, setsubmitLoading] = useState(false);

  const [errors, setErrors] = useState({});

  // fetch vendor data

  useEffect(() => {
    if (id) {
      dispatch(getVendor({ id }))
        .unwrap()
        .then((res) => {
          const vendor = res?.vendors?.[0];

          setForm({
            name: vendor.name || "",
            contactPerson: vendor.contactPerson || "",
            mobileNumber: vendor.mobileNumber || "",
            email: vendor.email || "",
            address: vendor.address || "",
            city: vendor.city || "",
            state: vendor.state || "",
            country: vendor.country || "",
            pincode: vendor.pincode || "",
            gstNumber: vendor.gstNumber || "",
            panNumber: vendor.panNumber || "",
            creditDays: vendor.creditDays?.toString() || "",
            paymentTerms: vendor.paymentTerms || "",
            notes: vendor.notes || "",
            bankDetails: {
              accountName: vendor.bankDetails?.accountName || "",
              accountNumber: vendor.bankDetails?.accountNumber || "",
              ifscCode: vendor.bankDetails?.ifscCode || "",
              bankName: vendor.bankDetails?.bankName || "",
              branch: vendor.bankDetails?.branch || "",
            },
          });

          setService(vendor.services || []);
        })
        .catch(() => {
          toast.error("Failed to fetch vendor");
        });
    }
  }, [id, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;
    let error = "";

    if (["gstNumber", "panNumber"].includes(name)) {
      updatedValue = value.toUpperCase();
    }

    const gstRegex =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    // Company Name
    if (name === "name") {
      if (!updatedValue.trim()) {
        error = "Please enter company name";
      } else if (!/^[a-zA-Z0-9][\s\S]*$/.test(updatedValue)) {
        error = "Company name must contain letters only";
      }
    }

    // contactperson

    if (name === "contactPerson") {
      if (!updatedValue.trim()) {
        error = "Please enter contact person name";
      } else if (!/^[A-Za-z'\s]+$/.test(updatedValue)) {
        error = "Contact person must contain letters only";
      }
    }

    // mobilenumber

    if (name === "mobileNumber") {
      if (!updatedValue.trim()) {
        error = "Please enter mobile number";
      } else if (!mobileregex.test(updatedValue)) {
        error = "Enter valid 10-digit mobile number";
      }
    }

    // email
    if (name === "email") {
      const value = updatedValue;

      if (!value.trim()) {
        error = "Please enter email";
      } else if (value.includes(" ")) {
        error = "Email should not contain spaces";
      } else if (value.includes("*")) {
        error = "Masked email is not allowed";
      } else if (!emailregex.test(value)) {
        error = "Please enter valid Email Address";
      } else {
        error = "";
      }
    }

    // pincode
    if (name === "pincode") {
      if (!/^\d{6}$/.test(updatedValue)) error = "Pincode must be 6 digits";
    }

    // Service
    if (name === "service") {
      if (!value) {
        error = "Please select service";
      }
    }

    // Address ---- >
    if (name === "address") {
      if (!updatedValue.trim()) {
        error = "Please enter address";
      }
    }

    // City <-----
    if (name === "city") {
      if (!updatedValue.trim()) {
        error = "Please enter city";
      }
    }

    // State --->
    if (name === "state") {
      if (!updatedValue.trim()) {
        error = "Please select state";
      }
    }

    // Country <-----
    if (name === "country") {
      if (!updatedValue.trim()) {
        error = "Please enter country";
      }
    }

    // GST ---- >
    if (name === "gstNumber") {
      if (updatedValue && !gstRegex.test(updatedValue)) {
        error = "Invalid GST Number";
      }
    }

    if (name === "panNumber") {
      if (updatedValue && !panRegex.test(updatedValue)) {
        error = "Invalid PAN Number";
      }
    }

    if (name === "creditDays") {
      const creditValue = String(updatedValue || "").trim();

      if (creditValue && !/^\d+$/.test(creditValue)) {
        error = "Credit days must be numeric";
      }
    }

    // Payment Terms (optional but letters only)
    if (name === "paymentTerms") {
      const paymentValue = updatedValue.trim();

      if (paymentValue && !/^[A-Za-z\s]+$/.test(paymentValue)) {
        error = "Payment terms must contain letters only";
      }
    }

    setForm((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const handleBankChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    if (name === "ifscCode") {
      updatedValue = value.toUpperCase();
    }

    setForm((prev) => ({
      ...prev,
      bankDetails: {
        ...prev.bankDetails,
        [name]: updatedValue,
      },
    }));

    validateBankField(name, updatedValue);
  };

  const validateBankField = (name, value) => {
    let error = "";
    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

    if (name === "accountNumber" && value && !/^\d+$/.test(value))
      error = "Account number must be numeric";

    if (name === "ifscCode" && value && !ifscRegex.test(value))
      error = "Invalid IFSC Code";

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const validate = () => {
    let newErrors = {};

    const gstRegex =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

    /* REQUIRED FIELDS */

    if (!form.name.trim()) newErrors.name = "Please enter company name";

    if (!form.contactPerson.trim())
      newErrors.contactPerson = "Please enter contact person";

    if (!mobileregex.test(form.mobileNumber))
      newErrors.mobileNumber = "Please enter valid mobile number";

    if (!emailregex.test(form.email))
      newErrors.email = "Please enter valid email";

    if (!form.address.trim()) newErrors.address = "Please enter address";

    if (!form.city.trim()) newErrors.city = "Please enter city";

    if (!form.state.trim()) newErrors.state = "Please select state";

    if (!form.country.trim()) newErrors.country = "Please enter country";

    if (!/^\d{6}$/.test(form.pincode))
      newErrors.pincode = "Pincode must be 6 digits";

    if (!service.length) newErrors.service = "Please select service";

    /* OPTIONAL FORMAT VALIDATION */

    if (form.gstNumber.trim() && !gstRegex.test(form.gstNumber))
      newErrors.gstNumber = "Invalid GST Number";

    if (form.panNumber.trim() && !panRegex.test(form.panNumber))
      newErrors.panNumber = "Invalid PAN Number";

    if (form.creditDays.trim() && !/^\d+$/.test(form.creditDays))
      newErrors.creditDays = "Credit days must be numeric";

    if (form.paymentTerms.trim() && !/^[A-Za-z\s]+$/.test(form.paymentTerms))
      newErrors.paymentTerms = "Payment terms must contain letters only";

    /* BANK GROUP VALIDATION */

    const { accountName, accountNumber, ifscCode, bankName, branch } =
      form.bankDetails;

    const isAnyBankFieldFilled =
      accountName.trim() ||
      accountNumber.trim() ||
      ifscCode.trim() ||
      bankName.trim() ||
      branch.trim();

    if (isAnyBankFieldFilled) {
      if (!accountName.trim())
        newErrors.accountName = "Account name is required";

      if (!accountNumber.trim())
        newErrors.accountNumber = "Account number is required";

      if (!ifscCode.trim()) newErrors.ifscCode = "IFSC Code is required";

      if (!bankName.trim()) newErrors.bankName = "Bank name is required";

      if (!branch.trim()) newErrors.branch = "Branch name is required";
    }

    if (ifscCode.trim() && !ifscRegex.test(ifscCode))
      newErrors.ifscCode = "Invalid IFSC Code";

    if (form.notes && form.notes.length > 200)
      newErrors.notes = "Maximum 200 characters allowed";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setsubmitLoading(true);

    try {
      const payload = {
        id,
        ...form,
        services: service,
      };

      await dispatch(updateVendor(payload)).unwrap();
      toast.success("Vendor update Successfully ");
      navigate("/hotel/vendor");
      setForm(initialform);

      setErrors({});
    } catch (error) {
      toast.error(error || "Failed to edit service provider");
    } finally {
      setsubmitLoading(false);
    }
  };

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/hotel/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>
          <Link to="/hotel/vendor" className="breadcrumb-link active">
            Service Providers
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span className="breadcrumb-link inactive">Edit</span>
        </div>
      </div>
      <Container className="mt-4">
        <Card className="shadow-sm p-4" style={{ border: "none" }}>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Company Name</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter company name"
                        value={form.name}
                        maxLength={50}
                        onChange={handleChange}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.name}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Contact Person</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="contactPerson"
                        placeholder="Enter contact person name"
                        value={form.contactPerson}
                        onChange={handleChange}
                        maxLength={50}
                      />
                    </InputGroup>
                    <small className="text-danger">
                      {errors.contactPerson}
                    </small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Mobile Number</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="mobileNumber"
                        maxLength={10}
                        placeholder="Enter mobile number"
                        value={form.mobileNumber}
                        onChange={(e) => {
                          if (/^\d*$/.test(e.target.value)) handleChange(e);
                        }}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.mobileNumber}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="email"
                        placeholder="Enter emaill"
                        value={form.email}
                        onChange={handleChange}
                        maxLength={75}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.email}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Service</Form.Label>

                    <Select
                      isMulti
                      options={serviceOptions}
                      value={serviceOptions.filter((option) =>
                        service.includes(option.value),
                      )}
                      onChange={(selectedOptions) => {
                        const values = selectedOptions
                          ? selectedOptions.map((option) => option.value)
                          : [];

                        setService(values);

                        setErrors((prev) => ({
                          ...prev,
                          service: "",
                        }));
                      }}
                      placeholder="Select Services"
                    />

                    <small className="text-danger">{errors.service}</small>
                    <small className="text-danger">{errors.service}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="address"
                        placeholder="Enter Address"
                        value={form.address}
                        onChange={handleChange}
                        maxLength={400}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.address}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>City</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="city"
                        placeholder="Enter city name"
                        value={form.city}
                        onChange={handleChange}
                        maxLength={30}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.city}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>State</Form.Label>
                    <InputGroup>
                      <Form.Select
                        name="state"
                        value={form.state}
                        onChange={handleChange}
                      >
                        <option value="">Select</option>
                        {stateOptions.map((state, index) => (
                          <option key={index} value={state}>
                            {state}
                          </option>
                        ))}
                      </Form.Select>
                    </InputGroup>
                    <small className="text-danger">{errors.state}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Country</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="country"
                        placeholder="Enter country name"
                        value={form.country}
                        onChange={handleChange}
                        maxLength={30}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.country}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Pincode</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="pincode"
                        maxLength={6}
                        placeholder="Enter pincode"
                        value={form.pincode}
                        onChange={(e) => {
                          if (/^\d*$/.test(e.target.value)) handleChange(e);
                        }}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.pincode}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>GST Number</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="gstNumber"
                        maxLength={15}
                        placeholder="Enter GST number"
                        value={form.gstNumber}
                        onChange={handleChange}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.gstNumber}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>PAN</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="panNumber"
                        maxLength={10}
                        placeholder="Enter PAN"
                        value={form.panNumber}
                        onChange={handleChange}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.panNumber}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Credit Days</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="creditDays"
                        placeholder="Enter credit days"
                        maxLength={2}
                        value={form.creditDays}
                        onChange={(e) => {
                          if (/^\d*$/.test(e.target.value)) handleChange(e);
                        }}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.creditDays}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Payment Terms</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="paymentTerms"
                        placeholder="Enter payment terms"
                        value={form.paymentTerms}
                        onChange={handleChange}
                        maxLength={200}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.paymentTerms}</small>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Account Name</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="accountName"
                        placeholder="Enter account name"
                        value={form.bankDetails.accountName}
                        onChange={(e) => {
                          if (/^[A-Za-z\s]*$/.test(e.target.value)) {
                            handleBankChange(e);
                          }
                        }}
                        maxLength={50}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.accountName}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Account Number</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="accountNumber"
                        placeholder="Enter account number"
                        value={form.bankDetails.accountNumber}
                        inputMode="numeric"
                        maxLength={15}
                        onChange={(e) => {
                          if (/^\d*$/.test(e.target.value)) handleBankChange(e);
                        }}
                      />
                    </InputGroup>
                    <small className="text-danger">
                      {errors.accountNumber}
                    </small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>IFSC Code</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="ifscCode"
                        maxLength={11}
                        placeholder="Enter IFSC Code"
                        value={form.bankDetails.ifscCode}
                        onChange={handleBankChange}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.ifscCode}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Bank Name</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="bankName"
                        placeholder="Enter bank name"
                        value={form.bankDetails.bankName}
                        onChange={(e) => {
                          if (/^[A-Za-z\s]*$/.test(e.target.value)) {
                            handleBankChange(e);
                          }
                        }}
                        maxLength={50}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.bankName}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Branch</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="branch"
                        placeholder="Enter Branch Name"
                        value={form.bankDetails.branch}
                        onChange={handleBankChange}
                        maxLength={30}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.branch}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Notes</Form.Label>
                    <InputGroup>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="notes"
                        placeholder="Enter Notes (Optional)"
                        value={form.notes}
                        onChange={handleChange}
                        maxLength={300}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.notes}</small>
                  </Form.Group>
                </Col>
              </Row>

              {/* Buttons */}
              <div className="text-center d-flex justify-content-center align-items-center mt-5 mb-5">
                <button
                  type="button"
                  className="cancel-btn me-3"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="submit-btn d-flex align-items-center justify-content-center"
                  disabled={submitloading}
                >
                  {submitloading ? (
                    <>
                      <Spinner
                        animation="border"
                        size="sm"
                        variant="light"
                        className="me-2"
                      />
                      Submitting...
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}
